/*
 * Copyright (C) 2018 - 2023 Entgra (Pvt) Ltd, Inc - All Rights Reserved.
 *
 * Unauthorised copying/redistribution of this file, via any medium is strictly prohibited.
 *
 * Licensed under the Entgra Commercial License, Version 1.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       https://entgra.io/licenses/entgra-commercial/1.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import React from 'react';
import { Progress } from 'antd';
import styles from './styles.module.css';
import { useTranslation } from 'react-i18next';

export const Storage = props => {
  let { current, total, deviceType } = props;
  const { t } = useTranslation();
  if (props.title.includes(t('label_RAMUsage'))) {
    total = total / Math.pow(1024, 3);
    current = current / Math.pow(1024, 3);
  }
  const percentage = Math.round(((total - current) / total) * 100);
  let strokeColor = '#7cb304';
  if (percentage > 90) {
    strokeColor = '#eb4d4b';
  } else if (percentage > 60) {
    strokeColor = '#ffa718';
  }
  return (
    <div className={styles.container}>
      {deviceType.toLowerCase() === 'windows' ? (
        <div>
          <div>{props.title}</div>
          <small className={styles.value}>
            <b>{parseFloat((current / 1024).toFixed(2))} GB</b>
          </small>
        </div>
      ) : (
        <div>
          <div>{props.title}</div>

          <Progress
            strokeWidth={10}
            percent={percentage}
            size="small"
            strokeColor={strokeColor}
            status="active"
            trailColor={'#e3e3e3'}
          />

          <small className={styles.smallText}>
            <b>{parseFloat((total - current).toFixed(2))} GB</b>{' '}
            {t('label_used_of')} <b>{parseFloat(total.toFixed(2))} GB</b>
          </small>
        </div>
      )}
    </div>
  );
};

export default Storage;
